// Shared Birtvy document types + page geometry. DOC_W/DOC_H MUST equal DeckGen's DOC_PAGE (UserDocCards.tsx)
// so the ported doc editor + prose CSS lay out identically. Birtvy docs use NUMBER ids (idRef counter),
// unlike the product's string ids.

export const DOC_W = 764
export const DOC_H = 1080

export interface BirtvyDoc {
  id: number
  x: number
  y: number
  width: number
  height: number
  /** Mixed-type canvas group membership (birtvyGroup.ts) — null/undefined = ungrouped. */
  groupId?: number | null
  /** Markdown — the single source of truth for the doc body. */
  content: string
  /** Derived from `content` (deriveDocTitle) — the first heading/line. */
  title: string
  /** Backref to the backend Library document, when placed from it. */
  documentId?: string
  /** /deck projection of a canonical planning/Library resource. Not a second original. */
  resourceKey?: string
  streaming?: boolean
}

/** The card's on-screen rect captured when it opens, so the fullscreen editor can morph from it. */
export interface BirtvyDocOrigin {
  x: number
  y: number
  width: number
  height: number
}
